import React from 'react';
import {observer} from "mobx-react";
import {VideoSlidesArenaFiltersIndicatorBox} from './boxes/video-slides-arena-filters-indicator.box';
import {useServices} from '../../../../../../react-hooks/use-services.hook';
import {
    VideoSlidesHeaderFilterButtonComponent
} from "../video-slides-header-filter-button/video-slides-header-filter-button.component";
import {Check} from "@sparkware/app-utils";
import {IVideoSlidesFilterViewModel} from '../../../../../../services/video-slides/models/video-slides-filter-editor/video-slides-filter-view-model.interface';
import {CyClass} from "../../../../../../../common/cy-classes";


export const VideoSlidesArenaFiltersIndicator: React.FC = observer(() => {
    const services = useServices();

    const renderSingleFilter = (videoSlidesFilter: IVideoSlidesFilterViewModel) => {
        if (!videoSlidesFilter.shouldBeDisplayed) {
            return null;
        }

        return <VideoSlidesHeaderFilterButtonComponent
            key={videoSlidesFilter.title}
            videoSlidesFilterEditor={videoSlidesFilter}
            textTranslationKey={videoSlidesFilter.title}
            icon={Check.isNullOrUndefined(videoSlidesFilter.icon) ? null : services.theme.currentTheme.icons[videoSlidesFilter.icon]}
        />
    }

    return (
        <VideoSlidesArenaFiltersIndicatorBox className={CyClass('cy-video-slides-filters-container')}>
            {services.videoSlides.videoSlidesFilters.map(filterConfig => renderSingleFilter(filterConfig))}
        </VideoSlidesArenaFiltersIndicatorBox>
    );
})